module.exports = __webpack_public_path__ + "img/hc.894ec843.webp";